import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlSettings } from '../../ControlSettings';


@Component({
  selector: 'checkbox-input-ctrl',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxInputComponent,
    multi: true
  }]
})
export class CheckboxInputComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() isLarge: boolean;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {uppercase:false, fxFill:false, readonly: false};

  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    if(this.settings.readonly) {
      this.control.disable();
    }
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  onChange(value:string){
    this.valueChangeEvent.emit(value);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
